import {makeStyles} from "@material-ui/core/styles";
import bgImage from "../images/bgImage.svg";

export const useStyles = makeStyles((theme) => ({
    headingTitle: {
        textAlign: 'center',
        fontSize: 35,
        fontWeight: 700,
        margin: theme.spacing(3, 0, 5),
        [theme.breakpoints.down("sm")]: {
            fontSize: 24,
            margin: theme.spacing(3, 0, 3),
        },
    },
    adminLayoutWrapper: {
        minHeight: 'calc(100vh - 150px)',
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center bottom',
    },
    adminCardWrapper: {
        marginTop: 100,
        [theme.breakpoints.down("sm")]: {
            marginTop: 50,
        }
    },
}));

